import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-blue-900 text-white relative overflow-hidden" data-id="element-85">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#f59e0b 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-86"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-87">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="inline-flex items-center justify-center w-24 h-24 bg-amber-500 rounded-full mb-8 shadow-xl shadow-amber-500/20" data-id="element-88">
          <ShieldCheck className="w-12 h-12 text-blue-950" data-id="element-89" />
        </motion.div>

        <h2 className="text-3xl md:text-5xl font-bold mb-8 text-amber-400" data-id="element-90">
          🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <div className="text-xl md:text-2xl font-medium space-y-6 text-blue-50" data-id="element-91">
          <p data-id="element-92">Abrís los tomos. Los usás con tu familiar.</p>
          <p data-id="element-93">Si en 7 días no es lo que esperabas:</p>
          <div className="bg-blue-800/80 border border-blue-700 p-6 rounded-2xl my-8 transform rotate-1" data-id="element-94">
            <p className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-95">
              devolución del 100%
            </p>
            <p className="text-amber-400" data-id="element-96">sin formularios, sin drama.</p>
          </div>
          <p className="text-lg text-blue-200/80" data-id="element-97">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </div>
    </section>;
}